import { render, staticRenderFns } from "./PrerequisitePage.vue?vue&type=template&id=d9a9b40e"
import script from "./PrerequisitePage.vue?vue&type=script&lang=js"
export * from "./PrerequisitePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports